const theme = {
  mainBg:
    "rgba(0, 0, 0, 0) radial-gradient(circle at center center, rgb(255, 234, 229), rgb(255, 241, 230), rgb(255, 249, 227), rgb(233, 250, 243), rgb(232, 243, 252), rgb(234, 235, 253)) repeat scroll 0% 0%",
  redBg: "rgba(255,0,0, 0.7)",
  redBgHover: "rgba(255, 0, 0, 0.3)",
  redBgFocus: "#000"
};

export default theme;
